export default "__VITE_ASSET__CJ1q57JC__"